import { ExcelImportModal } from '../../../excel-import-modal-interface/excel-import-modal.interface';

export const dispatchToCustomerImport: ExcelImportModal = {
    importTitle: 'Descargar plantilla',
    exportTitle: 'Sube tus despachos',
    importInfoBlacked: 'Será tu guía',
    importInfo: 'para poder importar tu lista de despachos.',
    exportInfoBlacked: 'Sube tu plantilla',
    exportInfo: 'que llenaste con los despachos que serán cargados al viaje.',
    excelNameTemplate: 'despachosPlantilla.xlsx',
    headers: ['N° de despacho'],
    multiple: true,
    templateList: [
        {
            text: 'Por Viajes',
            svgIcon: 'car',
            icon: null,
            excelNameTemplate: 'viajesPlantilla.xlsx',
            headers: ['Viaje - Ruta', 'Orden', 'N° de despacho'],
            tripModes: ['TRIP_TO_CUSTOMER'],
            formatType: 'dispatchesToLoadTrip',
            importType: 'importExcelByDispatches'
        },
        {
            text: 'Por Despachos',
            svgIcon: 'product',
            icon: null,
            excelNameTemplate: 'despachosPlantilla.xlsx',
            headers: ['N° de despacho'],
            tripModes: ['TRIP_TO_CUSTOMER','TRIP_BETWEEN_ENTITIES'],
            formatType: 'dispatchesToLoad',
            importType: 'importExcelByDispatches'
        },
        {
            text: 'Por SKU',
            svgIcon: 'locate',
            icon: null,
            excelNameTemplate: 'skuPlantilla.xlsx',
            headers: ['N° de despacho', 'SKU', 'Cantidad a despachar'],
            tripModes: ['TRIP_TO_CUSTOMER','TRIP_BETWEEN_ENTITIES'],
            formatType: 'dispatchesToLoad',
            importType: 'importExcelBySku'
        }
    ]
};
